import { DH } from '../hooks';
export var HOOK = "data-shape-id";
export var radiansToDegrees = function (radians) {
    if (radians === void 0) { radians = 0; }
    var degrees = radians * (180 / Math.PI);
    return degrees > 180 ? degrees - 360 : degrees;
};
export var degreesToRadians = function (degrees) {
    if (degrees === void 0) { degrees = 0; }
    return (degrees * Math.PI) / 180;
};
export var reverseDegrees = function (degrees) { return 360 - degrees; };
export var getElementHookValue = function (id, idPostfix) {
    if (idPostfix === void 0) { idPostfix = ''; }
    var postfix = idPostfix ? "-".concat(idPostfix) : '';
    return "".concat(id).concat(postfix);
};
export var getElementQuery = function (id, idPostfix) {
    var attributeValue = getElementHookValue(id, idPostfix);
    return "[".concat(HOOK, "=\"").concat(attributeValue, "\"]");
};
export var getViewBoxString = function (_a) {
    var scale = _a.scale, container = _a.container, initialX = _a.x, initialY = _a.y;
    var _b = getScaledPannedViewBox({ scale: scale, container: container, x: initialX, y: initialY }), x = _b.x, y = _b.y, width = _b.width, height = _b.height;
    return "".concat(x, " ").concat(y, " ").concat(width, " ").concat(height);
};
export var getScaledPannedViewBox = function (_a) {
    var scale = _a.scale, container = _a.container, initialX = _a.x, initialY = _a.y;
    var _b = getScaledViewBox({ scale: scale, container: container }), centeringX = _b.centeringX, centeringY = _b.centeringY, width = _b.width, height = _b.height;
    var x = initialX - centeringX;
    var y = initialY - centeringY;
    return { x: x, y: y, width: width, height: height };
};
export var getScaledViewBox = function (_a) {
    var scale = _a.scale, container = _a.container;
    var clientWidth = container.clientWidth, clientHeight = container.clientHeight;
    var width = round(clientWidth / scale);
    var height = round(clientHeight / scale);
    var deltaWidth = width - clientWidth;
    var deltaHeight = height - clientHeight;
    return {
        centeringX: round(deltaWidth / 2),
        centeringY: round(deltaHeight / 2),
        width: width,
        height: height,
    };
};
// TODO: turn arguments into object
export var getFactualElementPosition = function (element, definition, svgContainer, svgViewBox, returnBoundingBox, useMeasuringRectangle) {
    var _a;
    if (returnBoundingBox === void 0) { returnBoundingBox = false; }
    if (useMeasuringRectangle === void 0) { useMeasuringRectangle = false; }
    var svgContainerPosition = svgContainer.getBoundingClientRect();
    var _b = getScaledViewBox({
        scale: svgViewBox.scale,
        container: svgContainer,
    }), centeringX = _b.centeringX, centeringY = _b.centeringY;
    var measuringRect = useMeasuringRectangle
        ? (_a = element.querySelector("[data-hook=".concat(DH.SHAPE_MEASURING_RECT, "]"))) !== null && _a !== void 0 ? _a : element
        : element;
    var _c = measuringRect.getBoundingClientRect(), boundingX = _c.x, boundingY = _c.y, boundingWidth = _c.width, boundingHeight = _c.height;
    var scaledBoundingWidth = boundingWidth / svgViewBox.scale;
    var scaledBoundingHeight = boundingHeight / svgViewBox.scale;
    var midX = (boundingX - svgContainerPosition.x) / svgViewBox.scale +
        round(scaledBoundingWidth / 2) -
        centeringX +
        svgViewBox.x;
    var midY = (boundingY - svgContainerPosition.y) / svgViewBox.scale +
        round(scaledBoundingHeight / 2) -
        centeringY +
        svgViewBox.y;
    if (returnBoundingBox) {
        var scaledBoundingX = midX - round(scaledBoundingWidth / 2);
        var scaledBoundingY = midY - round(scaledBoundingHeight / 2);
        return {
            x: scaledBoundingX,
            y: scaledBoundingY,
            width: scaledBoundingWidth,
            height: scaledBoundingHeight,
        };
    }
    var x = midX - round(definition.width / 2);
    var y = midY - round(definition.height / 2);
    return { x: x, y: y, width: definition.width, height: definition.height };
};
export var round = function (value, precision) {
    if (precision === void 0) { precision = 0.01; }
    return Math.round(value / precision) * precision;
};
export var floor = function (value, precision) {
    if (precision === void 0) { precision = 0.01; }
    return Math.floor(value / precision) * precision;
};
export var ceil = function (value, precision) {
    if (precision === void 0) { precision = 0.01; }
    return Math.ceil(value / precision) * precision;
};
export var getElement = function (id, svgContainer, idPostfix) {
    var existentElement = svgContainer.querySelector(getElementQuery(id, idPostfix));
    if (existentElement) {
        return existentElement;
    }
    return null;
};
export var getSvgSrc = function (svgElement, sourceFormatter) {
    if (sourceFormatter === void 0) { sourceFormatter = function (source) { return source; }; }
    if (!svgElement) {
        return null;
    }
    else {
        return 'data:image/svg+xml,' + encodeURIComponent(sourceFormatter(svgElement.innerHTML));
    }
};
export var unique = function (values) { return Array.from(new Set(values)); };
export var getInitialViewBox = function (plan) {
    var elements = plan.sectors.flatMap(function (_a) {
        var el = _a.elements;
        return el;
    });
    var calculatedInitialViewBox = elements.reduce(function (_a, _b) {
        var width = _a.width, height = _a.height, x = _a.x, y = _a.y;
        var _c = _b.config, config = _c === void 0 ? {} : _c;
        var maxX = Number(config.x) + Number(config.width);
        var maxY = Number(config.y) + Number(config.height);
        if (Number(config.x) < x) {
            x = Number(config.x);
        }
        if (Number(config.y) < y) {
            y = Number(config.y);
        }
        if (maxX > width) {
            width = maxX;
        }
        if (maxY > height) {
            height = maxY;
        }
        return { width: Math.ceil(width), height: Math.ceil(height), x: Math.floor(x), y: Math.floor(y) };
    }, { width: 0, height: 0, x: 99999, y: 99999 });
    var offset = 20;
    var width = calculatedInitialViewBox.width, height = calculatedInitialViewBox.height, x = calculatedInitialViewBox.x, y = calculatedInitialViewBox.y;
    var viewBoxObject = {
        width: width - x + offset,
        height: height - y + offset,
        x: x - offset,
        y: y - offset,
    };
    return "".concat(viewBoxObject.x, " ").concat(viewBoxObject.y, " ").concat(viewBoxObject.width, " ").concat(viewBoxObject.height);
};
export var hookToQuerySelector = function (hook) { return "[data-hook=\"".concat(hook, "\"]"); };
export var focusStage = function () {
    var element = document.querySelector(hookToQuerySelector(DH.STAGE));
    if (element) {
        element.focus();
    }
};
//# sourceMappingURL=utils.js.map